import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import FriendPanel from '../elements/FriendPanel';
import './FriendsPage.css'

interface FriendsPageState {
  slug: string;
  alert: string;
  message: string;
}

class FriendsPage extends React.Component<{}, FriendsPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      slug: '',
      alert: '',
      message: ''
    };

    this.onSlugChange = this.onSlugChange.bind(this);
    this.onSlugKeyDown = this.onSlugKeyDown.bind(this);
    this.onFriendUpdated = this.onFriendUpdated.bind(this);
  }

  componentDidMount() {
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
  }

  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
  }

  onSlugChange(e: React.FormEvent<HTMLInputElement>): void {
    this.setState({slug: e.currentTarget.value});
  };

  onSlugKeyDown(e:any): void {
    if (e.key === 'Enter') 
      this.onInvite();
  };

  onFriendUpdated(data: any) {
    this.forceUpdate();
  }

  async onInvite() {
    if (!this.state.slug.trim()) {
      this.setState({alert: 'Slug invalid.'});
      return;
    } 

    this.setState({message: 'Sending invite...'});

    setTimeout(async () => {
      let slug = this.state.slug;
      if(slug.substring(0, 1) == '@')
        slug = slug.substring(1);
  
      let response = await Server.user.inviteFriendBySlug(slug);

      if (response.success) {
        await Server.public.loadProfileFromSlug(slug);
        this.setState({message: ''});
      }
      else
        this.setState({alert: response.message, message: ''});
    }, 500);
  }

  renderFriends() {
    let friends = Server.user.getFriends();

    if(friends.length == 0) {
      return( 
        <div style={{color: '#ffffff80'}}>
          Ask your friends in real life for their PlayPlace Handle (eg. @mrburns) and enter it above.
          You can also find the handle of any player on the leaderboards by viewing their public profile.
        </div>        
      )
    }

    let sortedFriends = [];
    for(let i = 0; i < friends.length; i++) {
      let profile  = Server.public.getProfile(friends[i].id);
      let friend:any = {...profile, ...friends[i]};
      sortedFriends.push(friend);
    }

    sortedFriends.sort((a, b)=>{
      if(a.state == 'invited' && b.state != 'invited')
        return 1;
      else if(a.state != 'invited' && b.state == 'invited')
        return -1;

      if(a.state == 'accepted' && b.state != 'accepted')
        return 1;
      else if(a.state != 'accepted' && b.state == 'accepted')
        return -1;

      if(a.state == 'pending' && b.state != 'pending')
        return 1;
      else if(a.state != 'pending' && b.state == 'pending')
        return -1;

      if((a.presence && a.presence.online) && (!b.presence || !b.presence.online))
        return 1;
      else if((!a.presence || !a.presence.online) && (b.presence && b.presence.online))
        return -1;
        
      if(a.name > b.name)
        return -1;
      else if(a.name < b.name)
        return 1;

      return 0;
    })

    let divs = [];
    for(let i = sortedFriends.length-1; i >= 0; i--) 
      divs.push(<FriendPanel key={i} metadata={sortedFriends[i]} onUpdate={this.onFriendUpdated} />);

    return divs;
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;
      
    return (
      <div className="friends-page">

        <div className='friends-page-header'>
          <input
            className="friends-page-input"
            placeholder="Enter handle of user to invite"
            value={this.state.slug}
            onChange={this.onSlugChange}
            onKeyDown={this.onSlugKeyDown}>
          </input>
          <button onClick={() => this.onInvite()}>Invite</button>
        </div>

        <div className="friends-page-contents">
          {this.renderFriends()}
        </div>

        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default FriendsPage;